import type { DivisionEntity } from "@citychallenge/api-public";

interface QRMatch {
  ID: string;
  DIVISION_CODE: string;
  STORY_ID?: string;
  HIT_ID?: string;
  ALWAYS_RESTART?: boolean | null;
  LANG?: string | null;
  VARIABLES?: string | null;
}

interface WebConfig {
  API_URL: string;
  ENVIRONMENT_NAME: string;
  DIVISION_INFO?: DivisionEntity;
  QR_ACCESSIBLE: boolean;
  QR_MATCH?: QRMatch;
  IS_CATCH_ALL_DOMAIN: boolean;
  STORAGE_TYPE: "persistent" | "session";
  PRIVACY_MODE: "strict" | "loose" | "dynamic";
}

declare global {
  interface Window {
    __INTRACTIVE_CONFIG?: WebConfig;
  }
}

const config: Partial<WebConfig> = window.__INTRACTIVE_CONFIG || {};

export const WEB_CONFIG: WebConfig = {
  API_URL: config.API_URL || "http://localhost:3001",
  ENVIRONMENT_NAME: config.ENVIRONMENT_NAME || "intractive",
  DIVISION_INFO: config.DIVISION_INFO || undefined,
  STORAGE_TYPE: config.STORAGE_TYPE || ("persistent" as const),
  PRIVACY_MODE: config.PRIVACY_MODE || ("loose" as const),
  IS_CATCH_ALL_DOMAIN:
    typeof config.IS_CATCH_ALL_DOMAIN !== "undefined"
      ? config.IS_CATCH_ALL_DOMAIN
      : true,
  QR_ACCESSIBLE:
    typeof config.QR_ACCESSIBLE === "undefined" ? true : config.QR_ACCESSIBLE,
  QR_MATCH: config.QR_MATCH || undefined,
};
